import Vue from 'vue';
import { Score } from '@/model/score';
import { Prize } from '@/model/prize';
import { UserPrize } from '@/model/userPrize';
import { HttpOptions, HttpResponse } from 'vue-resource/types/vue_resource';
import * as Constants from '@/utils/constants';
import * as DateUtils from '@/utils/dateUtils';
import * as DTOUtils from '@/utils/dtoUtils';
import { PrizeDTO } from '@/dto/prizeDTO';
import { UserPrizeDTO } from '@/dto/userPrizeDTO';
import { ScoreDTO } from '@/dto/scoreDTO';
import moment from 'moment';

export class ScoreService extends Vue {

  constructor() {
    super();
  }

  public addScore(score: Score, token: string) {
    const scoreDTO: ScoreDTO = DTOUtils.getScoreDTO(score);
    const options: HttpOptions = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
      },
    };
    
    return this.$http.post(Constants.API_DEV_URL + '/' + 'score' + '/' + 'addScore' + '?' 
        + 'code=' + scoreDTO.userCode + '&points=' + scoreDTO.points + '&description=' + scoreDTO.description, JSON.stringify(scoreDTO), options);
  }

  public getAllPrizes(token: string): Promise<Array<Prize>> {
    const options: HttpOptions = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
      },
    };

    return new Promise((resolve, reject) => {
      this.$http.get(Constants.API_DEV_URL + '/' + 'prize' + '/' + 'all', options)
      .then((response) => {
        const prizeDTOList: Array<PrizeDTO> = response.data;
        const prizeList: Array<Prize> = new Array<Prize>();
        prizeDTOList.forEach((p) => {
          prizeList.push(DTOUtils.getPrizeModel(p));
        });
        resolve(prizeList);
      });
    });
  }

  public getPrize(id: string, token: string): Promise<Prize> {
    const options: HttpOptions = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
      },
    };

    return new Promise((resolve, reject) => {
      this.$http.get(Constants.API_DEV_URL + '/' + 'prize' + '/' + id, options)
      .then((response) => {
        const prizeDTO: PrizeDTO = response.data;
          resolve(DTOUtils.getPrizeModel(prizeDTO));
        });
    });
  }

  public addPrize(prize: Prize, token: string): Promise<HttpResponse> {
    const options: HttpOptions = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
        'Content-type': 'application/json',
      },
    };

    const prizeDTO: PrizeDTO = DTOUtils.getPrizeDTO(prize);

    return new Promise((resolve, reject) => {
      this.$http.post(Constants.API_DEV_URL + '/' + 'prize' + '/' + 'addPrize', JSON.stringify(prizeDTO), options)
      .then((response) => {
        resolve(response);
      });
    });
  }

  public updatePrize(prize: Prize, id: string,  token: string) {
    const options: HttpOptions = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
      },
    };

    const prizeDTO: PrizeDTO = DTOUtils.getPrizeDTO(prize);

    return new Promise((resolve, reject) => {
      this.$http.put(Constants.API_DEV_URL + '/' + 'prize' + '/' + 'updatePrize', JSON.stringify(prizeDTO), options)
      .then((response) => {
        resolve(response.status);
      });
    });
  }

  public redeemUserPrize(userPrize: UserPrize,  token: string) {
    const options: HttpOptions = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
      },
    };
    userPrize.collectionDate = new Date();
    const userPrizeDTO = DTOUtils.getUserPrizeDTO(userPrize);

    return new Promise((resolve, reject) => {
      // tslint:disable-next-line:max-line-length
      this.$http.patch(Constants.API_DEV_URL + '/' + 'userPrize' + '/' + 'usePrize', JSON.stringify(userPrizeDTO), options)
      .then((response) => {
        resolve(response);
      });
    });
  }

  public deletePrize(prize: Prize,  token: string) {
    const options: HttpOptions = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
      },
    };
    // tslint:disable-next-line:max-line-length
    return this.$http.delete(Constants.API_DEV_URL + '/' + 'prize' + '/' + 'deletePrize' + '?' + 'prizeId=' + prize.id, options);
  }

  public getUserScores(userCode: string,  token: string): Promise<Array<Score>> {
    const options: HttpOptions = {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Access-Control-Allow-Origin': '*',
            // tslint:disable-next-line:max-line-length
            'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
        },
    };

    return new Promise<Array<Score>>((resolve, reject) => {
        // tslint:disable-next-line:max-line-length
        this.$http.get(Constants.API_DEV_URL + '/' + 'score' + '/' + 'getUserScores' + '?' + 'code=' + userCode, options)
        .then((response) => {
            const scoresData: Array<ScoreDTO> = response.data;
            const scores: Array<Score> = new Array<Score>();
            scoresData.forEach((scoreDTO: ScoreDTO) => {
               scores.push(DTOUtils.getScoreModel(scoreDTO));
            });
            resolve(scores);
        });
    });
}

  public addUserPrize(userCode: string, id: string,  token: string) {
    const options: HttpOptions = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
        'Content-type': 'application/json',
      },
    };

    const prize = {
      userCode,
      prize: { id },
      bookingDate: DateUtils.dateToArray(new Date()),
    };

    return new Promise((resolve, reject) => {
      // tslint:disable-next-line:max-line-length
      this.$http.post(Constants.API_DEV_URL + '/' + 'userPrize' + '/' + 'addPrize' + '?code=' + userCode , JSON.stringify(prize), options)
      .then((response) => {
        resolve(response);
      });
    });
  }

  public uploadPrizeImage(prizeId: string, img: any,  token: string): Promise<HttpResponse> {
    const options: HttpOptions = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
        'Content-type': 'application/json',
      },
    };
    const formData = new FormData();
    formData.append('prizeId', prizeId);
    formData.append('file', img)
    return new Promise((resolve, reject) => {
      this.$http.post(Constants.API_DEV_URL + '/' + 'prize/setPrizeImage', formData, options)
      .then((response) => {
        console.log(response.data);
        resolve(response);
      });
    });
  }

  public softDeleteScore(score: Score, token: string): Promise<HttpResponse> {
    const options: HttpOptions = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
      },
    };

    return new Promise((resolve, reject) => {
      console.log(score.id);
      this.$http.put(Constants.API_DEV_URL + '/score/softDeleteScore?id=' + score.id, JSON.stringify(score), options)
      .then((response) => {
        resolve(response);
      });
    });
  }

  public downloadlScoreList(token: string, startDate: Date, endDate: Date) {

    const startDateParam: string = moment(startDate).format('YYYY-MM-DD');
    const endDateParam: string = endDate 
                                  ? moment(startDate).format('YYYY-MM-DD')
                                  : moment(new Date()).format('YYYY-MM-DD');

    const apiUrl: string = '/score/getAllScoresCsv?startDate=' + startDateParam + '&endDateParam=' + endDateParam;

    const options: HttpOptions = {
      headers: {
          'Authorization': 'Bearer ' + token,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
          'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
          'Accept': 'text/csv'
      },
    };

    this.$http.get(Constants.API_DEV_URL + apiUrl, options)
    .then((response) => {
      const blob = new Blob([response.data],{type:'text/csv'});
      if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      } else {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "scores.csv";
        link.click();
      }
      
    });
    
  }

}

